import React from 'react'

import classNames from 'classnames'

import { NavLink, useLocation } from 'react-router-dom'

import { useAuth } from '@shared/hooks/auth'

import { endOfMonth, format as dateFormat, startOfMonth } from 'date-fns'

import {
  FiBriefcase,
  FiFileText,
  FiGrid,
  FiMenu,
  FiTrello,
  FiUsers,
  FiX,
  FiZap
} from 'react-icons/fi'

import {
  Container,
  NavigationItem,
  NavigationList
} from './styles'

import { IoCashOutline } from 'react-icons/io5'

const currentMonth = [
  dateFormat(startOfMonth(new Date()), 'yyyy-MM-dd'),
  dateFormat(endOfMonth(new Date()), 'yyyy-MM-dd')
]

const menus = {
  wholesalers: [
    {
      title: 'Dashboard',
      url: '/wholesalers/dashboard',
      icon: FiGrid,
      permissions: ['wholesaler_dashboard:show']
    },
    {
      title: 'Vendas',
      icon: FiFileText,
      permissions: ['wholesaler_sales:list'],
      url: `/wholesalers/sales?start_date=${currentMonth[0]}&end_date=${currentMonth[1]}&status=APROVADA`
    },
    {
      title: 'Pagamentos',
      icon: IoCashOutline,
      classList: ['navigation__link--fab'],
      permissions: ['wholesaler_payments:list'],
      url: `/wholesalers/payments?created_at=${currentMonth[0]},${currentMonth[1]}`
    },
    {
      title: 'Clientes',
      url: '/wholesalers/customers',
      icon: FiBriefcase,
      permissions: ['wholesaler_customers:list']
    }
  ],
  dispatchers: [
    {
      title: 'Dashboard',
      url: '/dispatchers/dashboard',
      icon: FiGrid,
      permissions: ['dispatcher_dashboard:show']
    },
    {
      title: 'Suas Vendas',
      info: 'Prestação de Serviços',
      url: '/dispatchers/sales',
      icon: FiFileText,
      permissions: ['dispatcher_sales:list']
    },
    {
      title: 'Nova Venda',
      url: '/dispatchers/sales/new',
      icon: IoCashOutline,
      classList: ['navigation__link--fab'],
      permissions: ['dispatcher_sales:create']
    },
    {
      title: 'Clientes',
      url: '/dispatchers/customers',
      icon: FiUsers,
      permissions: ['dispatcher_customers:list']
    }
  ],
  finances: [
    {
      title: 'Dashboard',
      url: '/finances/dashboard',
      icon: FiGrid
      // permissions: []
    },
    {
      title: 'Despesas',
      icon: FiZap,
      permissions: ['finance_entries:list'],
      url: `/finances/entries?due_date=${currentMonth}`
    },
    {
      title: 'Categorias',
      url: '/finances/categories',
      icon: FiTrello,
      permissions: ['finance_categories:list']
    }
  ]
}

const BottomTabs = () => {
  const { module } = useAuth()

  const location = useLocation()

  const [isNavigationVisible, setIsNavigationVisible] = React.useState(false)

  const checkMenuPermission = React.useCallback(
    (menu) => {
      if (!menu.permissions) {
        return true
      } else {
        return menu.permissions.every((permission) => {
          return module.permissions.includes(permission)
        })
      }
    },
    [module]
  )

  const selectedModuleMenu = React.useMemo(() => {
    return menus[module?.name]?.filter(checkMenuPermission) || null
  }, [module, checkMenuPermission])

  const handleToggleNavigation = React.useCallback(() => {
    const navigation = document?.querySelector('.navigation')

    if (!navigation) return

    if (isNavigationVisible) {
      setIsNavigationVisible(false)
      navigation.classList.remove('navigation--visible')
    } else {
      setIsNavigationVisible(true)
      navigation.classList.add('navigation--visible')
    }
  }, [isNavigationVisible])

  React.useEffect(() => {
    const navigation = document?.querySelector('.navigation')
    if (!navigation) return
    setIsNavigationVisible(false)
    navigation.classList.remove('navigation--visible')
  }, [location.pathname])

  return (
    selectedModuleMenu && (
      <Container>
        <NavigationList>
          {selectedModuleMenu.map(
            ({ title, url, icon: Icon, classList = [] }, menuIdx) => (
              <NavigationItem key={`menu-item-${menuIdx}`}>
                <NavLink
                  exact
                  to={url}
                  className={classNames(['navigation__link', ...classList])}
                  activeClassName="navigation__link--active"
                >
                  <Icon size={24} />
                  {title}
                </NavLink>
              </NavigationItem>
            )
          )}

          <NavigationItem>
            <a
              href="#"
              className="navigation__link"
              onClick={handleToggleNavigation}
            >
              {isNavigationVisible ? (
                <>
                  <FiX size={20} />
                  Fechar
                </>
              ) : (
                <>
                  <FiMenu size={24} />
                  Menu
                </>
              )}
            </a>
          </NavigationItem>
        </NavigationList>
      </Container>
    )
  )
}

export default BottomTabs
